import {PATH_TASKS_TEMPLATE_SINGLE_VOYAGES} from "@constants/navigate";

export const buildPathToTaskTemplatesSingleVoyage = ({
                                                         accountId
                                                     }: {
    accountId: string | number
}): string => {
    return `${PATH_TASKS_TEMPLATE_SINGLE_VOYAGES}?accountId=${accountId}`
}

